import store from '../../../store'

const getDateFrom = () => {
  return store.getters.GET_DATE_FROM
}

const getDateTo = () => {
  return store.getters.GET_DATE_TO
}

const getDateFromStatic = () => {
  return store.getters.GET_DATE_FROM_STATIC
}

const getDateToStatic = () => {
  return store.getters.GET_DATE_TO_STATIC
}

const getDateFromActive = () => {
  return store.getters.GET_DATE_FROM_ACTIVE
}

const getDateToActive = () => {
  return store.getters.GET_DATE_TO_ACTIVE
}

const getDateStart = () => {
  return store.getters.GET_DATE_START
}

const getDateEnd = () => {
  return store.getters.GET_DATE_END
}

const getIsDate = () => {
  return store.getters.GET_IS_DATE_SET
}

const getIsDateValid = () => {
  return store.getters.GET_IS_DATE_VALID
}

const getIsPreviousDateValid = () => {
  return store.getters.GET_IS_PREVIOUS_DATE_VALID
}

const getDateGap = () => {
  return store.getters.GET_DATE_GAP
}

export {
  getDateFrom,
  getDateTo,
  getDateStart,
  getDateEnd,
  getIsDate,
  getIsDateValid,
  getIsPreviousDateValid,
  getDateGap,
  getDateFromStatic,
  getDateToStatic,
  getDateFromActive,
  getDateToActive
}



// WEBPACK FOOTER //
// ./src/scripts/modules/store/date-filters-getters.js